/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import { put, call, takeEvery} from 'redux-saga/effects';
import { CMSContent } from '../api/agent';
import {
    GET_POLICY_CONTENT_SUCCESS,
    GET_POLICY_CONTENT_FAILURE,
    GET_POLICY_CONTENT,

    SAVE_FEEDBACK_SUCCESS,
    SAVE_FEEDBACK__FAILURE,
    SAVE_FEEDBACK,


} from '../actions/actionTypes';

function* getPolicyContent(action) {
    try {
        const payload = yield call(CMSContent.getPolicyContent);
        yield put({ type: GET_POLICY_CONTENT_SUCCESS, payload });
    } catch (err) {
        const errResp = err.response.body;
        yield put({ type: GET_POLICY_CONTENT_FAILURE, errResp });
    }
}

export function* watchGetPolicyContent() {
    yield takeEvery(GET_POLICY_CONTENT, getPolicyContent);

}

function* saveFeedback(action) {
    try {
        const payload = yield call(CMSContent.saveFeedback, action.payload);
        yield put({ type: SAVE_FEEDBACK_SUCCESS, payload });
    } catch (err) {
        const errResp = err.response.body;
        yield put({ type: SAVE_FEEDBACK__FAILURE, errResp });
    }
}

export function* watchSaveFeedback() {
    yield takeEvery(SAVE_FEEDBACK, saveFeedback);
}
